module.exports = __webpack_public_path__ + "img/folder-blue.f2a0a032.svg";